import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = { class: "modal-box" }
const _hoisted_3 = { class: "content-box" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "description" }
const _hoisted_6 = { class: "footer" }
const _hoisted_7 = { style: {"text-align":"center","width":"100%"} }
const _hoisted_8 = { style: {"text-align":"center","width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.title), 1),
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_base_button, {
              border: "medium",
              size: "large",
              class: "btn mr-10",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onConfirm')))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.acceptCaption), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_base_button, {
              border: "medium",
              size: "large",
              variant: "outlined",
              class: "btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onCancel')))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.rejectCaption), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}